import React from "react";

export default function Index(props) {
  return (
    <div className={`flex flex-col ${props.newClassName} lg:flex-row h-screen w-full sm:pl-10 lg:fixed`}>
        {props.children}
    </div>
  );
}
